import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Alert, Typography, Spin, message as Toast } from 'antd';
import QRCode from 'react-qr-code';
import { useAuth } from 'hooks';

const WHATSAPP_URL = process.env.REACT_APP_API_URL;

export default function WhatsAppQRCode({ qrVisible, setQrVisible, setStatus, forceRefresh }) {
	const [qrString, setQrString] = useState();
	const [loading, setLoading] = useState(true);
	const userInfo = useAuth();
	const token = userInfo?.access_token;

	useEffect(() => {
		const source = new EventSource(`${WHATSAPP_URL}/whatsapp/qr?token=${token}`);
		source.onmessage = (event) => {
			try {
				const data = JSON.parse(event.data);
				if (data.status === 'qr') {
					console.log('QR code received:', data.qr);
					setQrString(data.qr);
					setLoading(false);
				} else if (data.status === 'connected') {
					setStatus('Connected');
					source.close();
					setQrVisible(false);
				} else if (data.status === 'closed') {
					setStatus('Disconnected');
					source.close();
					setLoading(false);
					setQrVisible(false);
					Toast.info('Error Occured. Please try again');
				}
			} catch (err) {
				if (event.data === 'done') {
					setLoading(false);
					setQrVisible(false);
					forceRefresh(true);
				} else {
					console.error('Invalid event data:', event.data);
					setLoading(false);
				}
			}
		};

		source.onerror = async () => {
			console.log('Error occurred with EventSource');
			source.close();
			setStatus('Disconnected');
			setLoading(false);
		};

		source.onopen = () => {
			console.log('EventSource connection established');
		};

		source.onclose = () => {
			console.log('EventSource connection closed');
		};

		return () => {
			console.log('Closing EventSource connection...');
			source.close();
		};
	}, []);

	const handleCloseQR = () => setQrVisible(false);

	let content;
	if (loading) {
		content = <Spin tip="Loading QR code..." />;
	} else if (qrString) {
		content = (
			<>
				<Typography.Title level={5}>Scan QR to login</Typography.Title>
				<QRCode value={qrString} />
				<Typography.Text italic>This QR will refresh automatically</Typography.Text>
			</>
		);
	} else {
		content = <Alert message="QR not available" type="info" />;
	}

	return (
		<Modal
			open={qrVisible}
			onCancel={handleCloseQR}
			footer={null}
			centered
			title="WhatsApp QR Code"
			maskClosable={false}
		>
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
				{content}
			</div>
		</Modal>
	);
}

WhatsAppQRCode.propTypes = {
	qrVisible: PropTypes.bool,
	setQrVisible: PropTypes.func,
	setStatus: PropTypes.func,
	forceRefresh: PropTypes.func,
};
